import { postRequest } from '@/core';
import { orders } from '@/requests';

export default async function getGeocodeOrdersRequest(ids) {
	let url = orders.getGeocodeOrdersPath();
	let response = await postRequest(url, {}, ids);
	return response;
}
